import { Directive, effect, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';
import { Permission, User } from '../models/user';

@Directive({
  selector: '[roleRestriction]'
})
export class RoleRestrictionDirective {
  @Input() roleRestriction!: Array<Permission> | Permission;
  
  private readonly authenticationService = inject(AuthenticationService);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef);
  
  constructor() {
    this.viewContainer.clear();

    effect(() => {
      const user = this.authenticationService.user() as User;

      if (user) this.checkUserPermissions();
    })
  }

  private checkUserPermissions(): void {
    if (this.authenticationService.isAuthorized(this.roleRestriction)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
